module.exports = __webpack_public_path__ + "static/assets/jenny-wills-profile.eba1359.png";